import { useState } from 'react'
import { Container, Tab, Tabs } from 'react-bootstrap'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { useTranslation } from 'react-i18next'
import RankTable from './components/RankTable'
import ScoreRankPage from './components/ScoreRankPage'
import { useQuery } from 'react-query'
import { getUserQuery } from 'dataLayer/user'

function RankPage() {
	const { t } = useTranslation()
	const { data: user } = useQuery(getUserQuery())
	const RANKING = {
		1: `${t('profile.gift_hist.today')}`,
		2: `${t('profile.gift_hist.this_week')}`,
		3: `${t('profile.gift_hist.this_month')}`,
	}
	const [key, setKey] = useState(1)
	const [tab, setTab] = useState('rank')
	return (
		<Container fluid className="rankpage-container">
			<div className="d-flex flex-column justify-content-between align-items-start my-3 tab-Rank">
				<Tabs
					id="controlled-tab-example"
					activeKey={tab}
					onSelect={k => setTab(k)}
					className="mx-0 mx-sm-2"
				>
					<Tab eventKey="rank">
						<div style={{ marginTop: '24px' }}>
							<RankTable time={key} />
						</div>
					</Tab>
					{/* <Tab eventKey="rank" title={t('rankpage.title')}>
						<RankTable time={key} />
					</Tab>
					<Tab eventKey="bxh" title={t('rankpage.title_t12')}>
						<ScoreRankPage />
					</Tab> */}
				</Tabs>
				<div className="rank-head-right">
					{tab == 'rank' ? (
						<Nav activeKey={key} onSelect={k => setKey(k)}>
							<NavDropdown title={RANKING[key]} align="end" id="nav-dropdown">
								<NavDropdown.Item eventKey={Object.keys(RANKING)[0]}>
									{t('rankpage.day')}
								</NavDropdown.Item>
								<NavDropdown.Item eventKey={Object.keys(RANKING)[1]}>
									{t('rankpage.week')}
								</NavDropdown.Item>
								<NavDropdown.Item eventKey={Object.keys(RANKING)[2]}>
									{`${t('rankpage.month')}`}
								</NavDropdown.Item>
							</NavDropdown>
						</Nav>
					) : user ? (
						<div style={{ fontSize: '16px' }}>{`${t('rankpage.my_point')} : ${user.point
							}`}</div>
					) : null}
				</div>
			</div>
		</Container>
	)
}

export default RankPage
